import { render, staticRenderFns } from "./rpRule.vue?vue&type=template&id=3fa438ea&"
import script from "./rpRule.vue?vue&type=script&lang=js&"
export * from "./rpRule.vue?vue&type=script&lang=js&"
import style0 from "./rpRule.vue?vue&type=style&index=0&id=3fa438ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports